let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kTZs1")).then(() => parcelRequire('hQPuK'));